let title = ' | Gestor - Comercial Ivaiporã'

const analise = {
    path: '/calculadorasolar',
    props: true,
    component: () => import('@/Components/Solar/SolarContainer'),
    children: [
        {
            path: '',
            name: 'CalculadoraSolar',
            component: () => import('@/Components/Solar/CalculadoraSolar.vue'),
            meta: {
                title: 'Solar' + title,
                permission: 'calculadora_solar',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Calculadora Solar',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '',
                    }
                ]
            }
        },
    ]
}

export default analise